/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Bot: 'Bot',
        Bot2: 'Bot2',
        Title: 'Title',
        Mine: 'Mine',
        Button: 'Button',
    },
    tomy:{
        kr: {
            Bot: '{name}님, 최근 현황을 보여드리겠습니다',
            Bot2: '아래 [매출보기]를 누르면 최근 3일간의 하위매출 확인도 가능합니다.',
            Title: '{name}님은 현재 {master}세요!',
            Mine: '나의 보유 PV',
            Button: '하위 매출 보기',            
        },
        eng: {
            Bot: '{name} is recent status',
            Bot2: 'If you click [View the purchase] below, then you can also check the group purchase for the last 3 days.',
            Title: '{name} currnet is {master}!',
            Mine: 'My PV',
            Button: 'View the group purchase',
        },    
    },
    papa:{
        kr: {
            Bot: '{name}님, 최근 현황을 보여드리겠습니다',
            Bot2: '아래 [매출보기]를 누르면 최근 3일간의 하위매출 확인도 가능합니다.',
            Title: '{name}님은 현재 {master}세요!',
            Mine: '나의 보유 PV',
            Button: '하위 매출 보기',            
        },
        eng: {
            Bot: '{name} is recent status',
            Bot2: 'If you click [View the purchase] below, then you can also check the group purchase for the last 3 days.',
            Title: '{name} current is {master}!',
            Mine: 'My PV',
            Button: 'View the group purchase',
        },    
    },
};
